/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__cost_title = /** @type {(inputs: {}) => string} */ () => {
	return `Die detaillierten Kosten für Ihre Fahrten`
};

const en_launchpad__cost_title = /** @type {(inputs: {}) => string} */ () => {
	return `The detailed cost of your journeys`
};

const es_launchpad__cost_title = /** @type {(inputs: {}) => string} */ () => {
	return `El coste detallado de sus viajes`
};

const fr_launchpad__cost_title = /** @type {(inputs: {}) => string} */ () => {
	return `Le coût détaillé de vos trajets`
};

const it_launchpad__cost_title = /** @type {(inputs: {}) => string} */ () => {
	return `Il costo dettagliato dei vostri viaggi`
};

const nl_launchpad__cost_title = /** @type {(inputs: {}) => string} */ () => {
	return `De gedetailleerde kosten van je reizen`
};

const pt_launchpad__cost_title = /** @type {(inputs: {}) => string} */ () => {
	return `O custo pormenorizado das suas viagens`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__cost_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__cost_title", locale)
	if (locale === "de") return de_launchpad__cost_title(inputs)
	if (locale === "en") return en_launchpad__cost_title(inputs)
	if (locale === "es") return es_launchpad__cost_title(inputs)
	if (locale === "fr") return fr_launchpad__cost_title(inputs)
	if (locale === "it") return it_launchpad__cost_title(inputs)
	if (locale === "nl") return nl_launchpad__cost_title(inputs)
	return pt_launchpad__cost_title(inputs)
};